import CompetitiveChart from './CompetitiveChart';
import './CompetitiveChart.scss';

export default CompetitiveChart;
